import { render, staticRenderFns } from "./ParentRouteView.vue?vue&type=template&id=71c95896&"
import script from "./ParentRouteView.vue?vue&type=script&lang=ts&"
export * from "./ParentRouteView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports